export const VIEW_SEND_MONEY_ACCOUNT = "VIEW_SEND_MONEY_ACCOUNT";
export const HIDE_SEND_MONEY_ACCOUNT = "HIDE_SEND_MONEY_ACCOUNT";
export const SET_BENEFICIARY_SWITCH_CLICK = "SET_BENEFICIARY_SWITCH_CLICK";
export const VERIFY_ACCOUNT_STARTED = "VERIFY_ACCOUNT_STARTED";
export const VERIFY_ACCOUNT_SUCCEDEED = "VERIFY_ACCOUNT_SUCCEDEED";
export const VERIFY_ACCOUNT_FAILED = "VERIFY_ACCOUNT_FAILED";
export const GET_BENEFICIARIES_STARTED = "GET_BENEFICIARIES_STARTED";
export const GET_BENEFICIARIES_SUCCEDEED = "GET_BENEFICIARIES_SUCCEDEED";
export const GET_BENEFICIARIES_FAILED = "GET_BENEFICIARIES_FAILED";
export const SELECTED_BANK_DATA = "SELECTED_BANK_DATA";
export const PROCESS_TRANSFER_STARTED = "PROCESS_TRANSFER_STARTED";
export const PROCESS_TRANSFER_SUCCEEDED = "PROCESS_TRANSFER_SUCCEEDED";
export const PROCESS_TRANSFER_FAILED = "PROCESS_TRANSFER_FAILED";
export const ADD_PAYMENT_SCHEDULE_STARTED = "ADD_PAYMENT_SCHEDULE_STARTED";
export const ADD_PAYMENT_SCHEDULE_SUCCEEDED = "ADD_PAYMENT_SCHEDULE_SUCCEEDED";
export const ADD_PAYMENT_SCHEDULE_FAILED = "ADD_PAYMENT_SCHEDULE_FAILED";
export const RESET_PAYMENTS = "RESET_PAYMENTS";
export const SET_BENEFICIARY_DATA = "SET_BENEFICIARY_DATA";
export const SET_FROM_BENEFICIARIES = "SET_FROM_BENEFICIARIES";
export const DELETE_BENEFICIARY_STARTED = "DELETE_BENEFICIARY_STARTED";
export const DELETE_BENEFICIARY_SUCCEDEED = "DELETE_BENEFICIARY_SUCCEDEED";
export const UPDATE_BENEFICIARIES_LIST = "UPDATE_BENEFICIARIES_LIST";
export const DELETE_BENEFICIARY_FAILED = "DELETE_BENEFICIARY_FAILED";
export const ADD_BENEFICIARY_STARTED = "ADD_BENEFICIARY_STARTED";
export const ADD_BENEFICIARY_SUCCEDEED = "ADD_BENEFICIARY_SUCCEDEED";
export const ADD_BENEFICIARY_FAILED = "ADD_BENEFICIARY_FAILED";
export const RELOAD_BENEFICIARY = "RELOAD_BENEFICIARY";
export const SET_PAYMENT_START_DATE = "SET_PAYMENT_START_DATE";
export const SET_PAYMENT_END_DATE = "SET_PAYMENT_END_DATE";
export const SET_SCHEDULE_FREQUENCY = "SET_SCHEDULE_FREQUENCY";
export const RESET_BENEFICIARY_STATE = "RESET_BENEFICIARY_STATE";
export const VALIDATE_PIN_STARTED = "VALIDATE_PIN_STARTED";
export const VALIDATE_PIN_SUCCEDEED = "VALIDATE_PIN_SUCCEDEED";
export const VALIDATE_PIN__FAILED = "VALIDATE_PIN__FAILED";
export const INITIATE_TRANSFER_STARTED = "INITIATE_TRANSFER_STARTED";
export const INITIATE_TRANSFER_SUCCEDEED = "INITIATE_TRANSFER_SUCCEDEED";
export const INITIATE_TRANSFER_FAILED = "INITIATE_TRANSFER_FAILED";
export const REQUEST_APPROVAL_STARTED = "REQUEST_APPROVAL_STARTED";
export const REQUEST_APPROVAL_SUCCEDEED = "REQUEST_APPROVAL_SUCCEDEED";
export const REQUEST_APPROVAL_FAILED = "REQUEST_APPROVAL_FAILED";

// SOURCE ACCOUNT BALANCE
export const FETCH_SOURCE_BALANCE_STARTED = "FETCH_SOURCE_BALANCE_STARTED";
export const FETCH_SOURCE_BALANCE_SUCCEDEED = "FETCH_SOURCE_BALANCE_SUCCEDEED";
export const FETCH_SOURCE_BALANCE_FAILED = "FETCH_SOURCE_BALANCE_FAILED";
export const GET_BANK_LIST_SUCCEEDED = "GET_BANK_LIST_SUCCEEDED"